/** Claims opened while the tenant's new claims flow was off keep the previous flow: no authorization step. */
export function usesNewFlow(claim: { isAuthorizationRequired?: boolean | null }) {
  return claim.isAuthorizationRequired !== false;
}
